import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Package } from 'lucide-react';
import { useProductScanner } from '../hooks/useProductScanner';
import { useRecentPurchaseToast } from '../hooks/useRecentPurchaseToast';
export function RecentPurchaseToast() {
  const products = useProductScanner();
  const {
    currentToast,
    isVisible
  } = useRecentPurchaseToast(products);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);
    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  if (!currentToast) return null;
  const animationVariants = prefersReducedMotion ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 80
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 80
    }
  };
  return <AnimatePresence data-id="element-614">
      {isVisible && <motion.div initial={animationVariants.initial} animate={animationVariants.animate} exit={animationVariants.exit} transition={{
      duration: prefersReducedMotion ? 0.2 : 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 right-4 z-50 max-w-sm mx-auto" data-id="element-615">
          <div className="bg-slate-800/95 backdrop-blur-sm border border-slate-700/50 rounded-xl shadow-lg p-4 flex items-center gap-4" data-id="element-616">
            {/* Product thumbnail or fallback icon */}
            {currentToast.product.thumbnailUrl ? <img src={currentToast.product.thumbnailUrl} alt={currentToast.product.title} className="w-12 h-12 rounded-lg object-cover shrink-0" data-id="element-617" /> : <div className="w-12 h-12 rounded-lg bg-slate-700/50 flex items-center justify-center shrink-0" data-id="element-618">
                <Package className="w-6 h-6 text-slate-400" data-id="element-619" />
              </div>}

            {/* Text content */}
            <div className="flex-1 min-w-0" data-id="element-620">
              <div className="flex items-center gap-2 mb-1" data-id="element-621">
                {/* Live indicator */}
                <div className="relative flex items-center" data-id="element-622">
                  <span className="absolute inline-flex h-2 w-2 rounded-full bg-emerald-400 opacity-75 animate-ping" data-id="element-623" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-624" />
                </div>
                <p className="text-sm text-slate-400 truncate" data-id="element-625">
                  {currentToast.name} in {currentToast.city} just purchased
                </p>
              </div>
              <p className="text-sm font-semibold text-slate-50 truncate" data-id="element-626">
                {currentToast.product.title}
              </p>
              <p className="text-xs text-slate-400 truncate" data-id="element-627">
                {currentToast.product.editionLabel} •{' '}
                <span className="text-amber-400 font-semibold" data-id="element-628">
                  {currentToast.product.priceText}
                </span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}